import { Chip, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export interface InfoItemProps {
	icon?: ReactNode;
	label?: string;
	value: string;
	spacing?: number;
	isChip?: boolean;
	color?: string;
}

export function InfoItem({
	icon,
	label,
	value,
	color,
	isChip,
	spacing = 2,
}: InfoItemProps) {
	if (isChip) {
		return (
			<Chip
				label={value}
				size="small"
				variant="outlined"
				color={
					color as
						| "default"
						| "primary"
						| "secondary"
						| "error"
						| "info"
						| "success"
						| "warning"
						| undefined
				}
			/>
		);
	}

	return (
		<Stack direction="row" alignItems="center" pl={1}>
			{icon && <Stack>{icon}</Stack>}
			<Typography variant="body2" ml={spacing} color="text.secondary">
				{label && value ? `${label}: ${value}` : value}
			</Typography>
		</Stack>
	);
}
